import React from 'react'

const Textarea = ({ onChange, placeholder, value }) => {
  return (
    <textarea onChange={onChange} placeholder={placeholder} value={value} />
  )
}

export default Textarea
